<template>
  <v-col
    cols="12"
  >
    <div class="d-flex mb-2 justify-end align-center" v-if="filteredItemsByYear.length">
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
            :prepend-icon="mdiMenuDown"
          >
            {{ currentYear }}
            <v-icon right>{{ mdiMenuDown }}</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in years"
            :key="index"
            @click="setYear(item)"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
    </v-menu>
    </div>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Suche nach Sammlungsname, Datum, Liturgischer Tag oder Summe"
          hide-details
          single-line
        ></v-text-field>
      </v-card-title>
      <v-data-table
        id="disbursement-orders-parent-table"
        :headers="headers"
        :items="sortedItems"
        :search="search"
        :custom-filter="customSearch"
        :sort-by="['end']"
        :sort-desc="[true]"
        item-key="plan"
        :single-expand="false"
        :expanded.sync="expanded"
        @update:expanded="onExpandedUpdate"
        show-expand
        dense
      >
        <template v-slot:expanded-item="{item, headers}">
          <td :colspan="headers.length">
            <div class="d-flex flex-column align-center">
              <v-data-table
                v-if="item.items && item.items.length"
                :item-class="(item) => item.state === DISBURSEMENT_STATE.CANCELLED ? 'cancelled' : ''"
                :items="item.items"
                :items-per-page="-1"
                :headers="childTableHeaders"
                class="disbursement-orders-parent-child-table mt-3 mb-3"
              >
                <template #item.current_organization_name="{ item }">
                  <router-link
                    :to="{ name: 'evaluation.org.disbursementOrders', params: { id: allOrganizations[item.organization].id } }"
                  >
                    {{ allOrganizations[item.organization].name }}
                  </router-link>
                </template>
                <template v-slot:item.state="{ item }">
                <span>
                  <v-tooltip
                    v-if="item.state === DISBURSEMENT_STATE.TRANSFERRED || item.count_transferred > 0"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="green darken-2"
                      >
                        {{ mdiCheckCircle }}
                      </v-icon>
                    </template>
                    <span>erledigt</span>
                  </v-tooltip>

                  <v-tooltip
                    v-else-if="item.state === DISBURSEMENT_STATE.IN_PROGRESS || item.count_in_progress > 0"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="orange"
                      >
                        {{ mdiAlert }}
                      </v-icon>
                    </template>
                    <span>zu bearbeiten </span>
                  </v-tooltip>

                  <v-tooltip
                    v-else
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="gray"
                      >
                        {{ mdiMinusCircle }}
                      </v-icon>
                    </template>
                    <span>abgewählt</span>
                  </v-tooltip>

                </span>
                </template>
                <template v-slot:item.sum_amount_total="{ item }">
                  <span>{{ (item.sum_amount_total || (Number(item.sum_amount_cash) + Number(item.sum_amount_pos) + Number(item.sum_amount_ecom))) || 0 | amount }} € </span>
                </template>
                <template v-slot:item.sum_amount_cash="{ item }">
                  <span>{{ item.sum_amount_cash || 0 | amount }} € </span>
                </template>
                <template v-slot:item.sum_amount_ecom="{ item }">
                  <span>{{ item.sum_amount_ecom|| 0 | amount }} € </span>
                </template>
                <template v-slot:item.sum_amount_pos="{ item }">
                  <span>{{ item.sum_amount_pos || 0 | amount }} € </span>
                </template>
                <template v-slot:item.download_pdf_action="{ item }">
                  <div
                    class="d-flex"
                    v-if="item.state != DISBURSEMENT_STATE.CANCELLED"
                  >
                    <v-btn
                      v-if="item.documents.length > 0 "
                      @click="$emit('downloadPdf', {url:item.documents[0], date: isoToHuman(item.stop_cash_payments, 'YYYY-MM-DD') })"
                      class="text-caption"
                      small
                      color="primary "
                    >
                      <v-icon class="mr-2">mdi-file-download</v-icon>
                      PDF
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </div>

      </td>
    </template>
      <template v-slot:item.plan_data.name="{ item }">
        <v-tooltip bottom v-if="item.plan_data.name">
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >
              {{ item.plan_data.name.length > 22 ? item.plan_data.name.substring(0, 45) + '...' : item.plan_data.name }}
            </span>
          </template>
          <span>{{ item.plan_data.name }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.plan_data.collection_variant="{ item }">
        <span>{{ $t(`dashboard.collectionType.${item.plan_data.collection_variant }`) }}</span>
      </template>
      <template v-slot:item.plan_data.day_name="{ item }">
        <span v-if="item.plan_data.date">
          {{ globalDatesByUrl[item.plan_data.date].name }}
        </span>
      </template>
      <template v-slot:item.plan_data.date_range="{ item }">
        <span v-if="item.plan_data.start && item.plan_data.end">
          {{ item.plan_data.start | isoToHuman('L') }} - {{ item.plan_data.end | isoToHuman('L') }}
        </span>
      </template>
      <template v-slot:item.plan_data.day="{ item }">
        <span>{{ item.plan_data.day || '- -' }}</span>
      </template>
      <template v-slot:item.sum_amount_total="{ item }">
        <strong>{{ item.sum_amount_total || 0 | amount }}&nbsp;{{ item.currency || "??" | currencySymbol }}</strong>
      </template>
      <template v-slot:item.sum_amount_cash="{ item }">
        <strong>{{ item.sum_amount_cash || 0 | amount }}&nbsp;{{ item.currency || "??" | currencySymbol }}</strong>
      </template>
      <template v-slot:item.sum_amount_ecom="{ item }">
        <strong>{{ item.sum_amount_ecom || 0 | amount }}&nbsp;{{ item.currency || "??" | currencySymbol }}</strong>
      </template>
      <template v-slot:item.sum_amount_pos="{ item }">
        <strong>{{ item.sum_amount_pos || 0 | amount }}&nbsp;{{ item.currency || "??" | currencySymbol }}</strong>
      </template>
      <template v-slot:item.counts="{ item }">
        <div class="d-flex align-center">
          <v-tooltip  bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="gray"> {{mdiMinusCircle}} </v-icon>
            </template>
            <span>abgewählt </span>
          </v-tooltip>
          <span>{{ item.count_canceled }} / {{ item.number_of_children }}</span>
        </div>
        <div class="d-flex align-center">
          <v-tooltip  bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="orange"> {{mdiAlert}} </v-icon>
            </template>
            <span>zu bearbeiten </span>
          </v-tooltip>
          <span>{{ item.count_in_progress }} / {{ item.number_of_children }}</span>
        </div>
        <div class="d-flex align-center">
          <v-tooltip   bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="green darken-2"> {{mdiCheckCircle}} </v-icon>
            </template>
            <span>erledigt </span>
          </v-tooltip>
          <span>{{ item.count_transferred }} / {{ item.number_of_children }}</span>
        </div>
      </template>
      </v-data-table>
    </v-card>
  </v-col>
</template>

<script>
import {
  monthMappingDe,
  monthMappingEn
} from "@/lib/search-by-month"
import {
  mdiEmailOpenOutline,
  mdiEmailOutline,
  mdiFileExcel,
  mdiHelpBox,
  mdiProgressClock,
  mdiArchiveOutline,
  mdiTextBoxMultipleOutline,
  mdiMenuDown,
  mdiCheckCircle,
  mdiAlert,
  mdiTableRemove,
  mdiMinusCircle
} from "@mdi/js"
import {
  mapGetters,
  mapState
} from "vuex"

import { CANCEL_DISBURSEMENT_ORDER } from "@/store/action-types"
import DISBURSEMENT_STATE from "@/lib/disbursement-state"
import { isoToHuman } from "@/filters/datetime"

export default {
  name: "EvalDisbursementParentOrganizationTable",
  emits: ["downloadPdf"],

  props: {
    headers: {
      type: Array,
      required: true
    },
    items: { type: Array },
  },
  data () {
    return {
      isoToHuman,
      DISBURSEMENT_STATE,
      mdiEmailOutline,
      mdiEmailOpenOutline,
      mdiFileExcel,
      mdiHelpBox,
      mdiProgressClock,
      mdiArchiveOutline,
      mdiTextBoxMultipleOutline,
      mdiMenuDown,
      mdiCheckCircle,
      mdiAlert,
      mdiTableRemove,
      mdiMinusCircle,
      selected: [],
      expanded: [],
      search: "",
      currentYear: new Date().getFullYear(),
      stopCashDialog: false,
      addCashCollectionDialog: false,
      selectedDisbursementOrder: null,
    }
  },
  methods: {
    customSearch (value, search, item) {
      search = search.toLowerCase()
      if (Object.keys(monthMappingEn).includes((search))) {
        search = "-" + monthMappingEn[search] + "-"
      }
      if (Object.keys(monthMappingDe).includes(search)) {
        search = "-" + monthMappingDe[search] + "-"
      }
      const searchableColumns = ['sum_amount_total', 'sum_amount_cash', 'sum_amount_pos', 'name', 'end', 'start', 'day']
      return Object.entries(item).some(([key, value]) => {
        if (value && typeof value === 'object') {
          return Object.entries(value).some(([nestedKey, nestedValue]) => {
            if (searchableColumns.includes(nestedKey)) {
              return nestedValue && nestedValue.toString().toLowerCase().includes(search)
            }
            return false
          })
        } else {
          if (searchableColumns.includes(key)) {
            return value && value.toString().toLowerCase().includes(search)
          }
        }

        return false
      })
    },
    setYear (year) {
      this.currentYear = year
    },
    cancelDisbursementOrder (id) {
      this.$store.dispatch(`disbursement/${CANCEL_DISBURSEMENT_ORDER}`, id)
    },
    onExpandedUpdate (collectionPlanSummaries) {
      collectionPlanSummaries.forEach(async (collectionPlanSummary) => {
        if (collectionPlanSummary.items && collectionPlanSummary.items.length) {
          return
        }
        const planId = collectionPlanSummary.plan_data.id
        const { data } = await this.$store.getters.restApi.get(`/disbursementorder/order/?plan=${planId}`)
        const sortedEntries = data.sort((a, b) => {
          if (a.state === b.state) {
            return this.allOrganizations[a.organization].name.localeCompare(this.allOrganizations[b.organization].name)
          }
          if (a.state === DISBURSEMENT_STATE.TRANSFERRED) return -1
          if (b.state === DISBURSEMENT_STATE.TRANSFERRED) return 1
          if (a.state === DISBURSEMENT_STATE.CANCELLED) return 1
          if (b.state === DISBURSEMENT_STATE.CANCELLED) return -1
          if (a.state === DISBURSEMENT_STATE.IN_PROGRESS) return -1
          if (b.state === DISBURSEMENT_STATE.IN_PROGRESS) return 1

          return 0
        })
        collectionPlanSummary.items = sortedEntries
      })
    },
  },
  computed: {
    ...mapGetters("organization", ["currentOrganization", "allOrganizations"]),
    ...mapGetters("date", ["globalDatesByUrl"]),
    ...mapState(['loading']),
    years () {
      return ['Alle', ...new Set(this.items.map(item => item.plan_data.end.split('-')[0]))]
    },
    filteredItemsByYear () {
      if (this.currentYear === 'Alle') {
        return this.items
      }
      return this.items.filter(item => {
        return item.plan_data.end.startsWith(this.currentYear)
      })
    },
    sortedItems () {
      return this.filteredItemsByYear.map(item => {
        if (!item.items || !item.items.length) {
          item.items = []
          return item
        }

        /*
        item.items = item.items.sort((itemA, itemB) => {
          if (itemA.count_transferred > itemB.count_transferred) {
            return -1
          }
          if (itemA.count_transferred < itemB.count_transferred) {
            return 1
          }

          if (itemA.count_in_progress > itemB.count_in_progress) {
            return -1
          }
          if (itemA.count_in_progress < itemB.count_in_progress) {
            return 1
          }

          if (itemA.count_canceled > itemB.count_canceled) {
            return -1
          }

          if (itemA.count_canceled < itemB.count_canceled) {
            return 1
          }
          if (itemA.current_organization_name > itemB.current_organization_name) {
            return 1
          }
          if (itemA.current_organization_name < itemB.current_organization_name) {
            return -1
          }

          return 0
        }) */

        return item
      })
    },
    effectiveOrganizationSettings () {
      return this.$store.getters["settings/effectiveSettingsForUrl"](this.currentOrganization.url)
    },
    childTableHeaders () {
      return [
        { text: "", value: "current_organization_name" },
        { text: "Spendensumme", value: "sum_amount_total" },
        { text: "Baranteil", value: "sum_amount_cash" },
        { text: "Online-Anteil", value: "sum_amount_ecom" },
        { text: "Geräte-Anteil", value: "sum_amount_pos" },
        { text: "", value: "state" },
        // { text: "", value: "download_pdf_action" },
      ]
    },
  },
}
</script>

<style lang="scss" >

#disbursement-orders-parent-table{
  .cancelled {
    color: #a7a7a7 !important;
    text-decoration: line-through;

  }
}

.disbursement-orders-parent-child-table {
  max-width: 850px;
  margin-left: 20px;
}
</style>
